document.addEventListener("DOMContentLoaded", function () {

  function updateHiddenInput(category, color) {
    let input = document.getElementById(`${category}-color`);
    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.id = `${category}-color`;
      input.name = `properties[${category} Color]`;
      document.querySelector('form[is="product-form"]').appendChild(input);
    }
    input.value = color;
  }

  function getAvailableCategories() {
    const categoryDivs = document.querySelectorAll('.kit-options > div');
    return Array.from(categoryDivs).map(div => div.getAttribute('data-category'));
  }

  function checkAllSelectionsMade() {
    const availableCategories = getAvailableCategories();
    let allSelected = true;

    for (const category of availableCategories) {
      if (!document.querySelector(`.thumbnail[data-category="${category}"].selected`)) {
        allSelected = false;
        break;
      }
    }

    const addToCartButton = document.querySelector('.buy-buttons button[type="submit"]:not([name])');
    const selectionMessage = document.querySelector('.selection-message');

    // --- DIAGNOSTIC LOGS --- 
    console.log("[DIAGNOSTIC] 'checkAllSelectionsMade' is running. Trying to find button with selector: '.buy-buttons button[type=\"submit\"]'");
    console.log("[DIAGNOSTIC] Button element found:", addToCartButton);

    if (addToCartButton) {
      const shouldBeDisabled = !allSelected;
      console.log(`[DIAGNOSTIC] 'allSelected' is ${allSelected}. Setting 'disabled' property to: ${shouldBeDisabled}`);
      addToCartButton.disabled = shouldBeDisabled;
      
      if (selectionMessage) {
        selectionMessage.style.display = allSelected ? 'none' : 'block';
      }
    } else {
      console.error("[DIAGNOSTIC] Could not find button to disable/enable.");
    }
  }

  function selectWaxOption(element) {
    const category = element.dataset.category;
    const color = element.dataset.productTitle;

    document.querySelectorAll(`.thumbnail[data-category="${category}"]`).forEach(thumb => thumb.classList.remove("selected"));
    element.classList.add("selected");
    updateHiddenInput(category, color);
    checkAllSelectionsMade();
  }

  // --- Main Execution ---

  // 1. Set the initial state on page load. This disables the button.
  // Use a small delay to ensure the DOM is fully ready
  setTimeout(checkAllSelectionsMade, 100);

  // 2. Set up click listeners using event delegation (works for dynamically added elements)
  document.addEventListener('click', function(event) {
    const thumbnail = event.target.closest('.thumbnail');
    if (thumbnail) {
      selectWaxOption(thumbnail);
    }
  });

  // 3. THE FIX: The theme's JavaScript fires a 'variant:change' event on the product
  //    form when it finishes loading the product's data. This happens even for
  //    products without variants. The theme's script listens for this and enables the
  //    'Add to Cart' button. We listen for the *exact same event* to re-run our check
  //    immediately after, ensuring our logic (disabling the button if options aren't
  //    selected) is the last to run.
  const productForm = document.querySelector('form[is="product-form"]');
  if (productForm) {
    productForm.addEventListener('variant:change', function() {
      // A minimal timeout ensures our check runs after the theme's own listeners
      // for this same event have finished.
      setTimeout(checkAllSelectionsMade, 1);
    });
  }
});
